import React from 'react';

/**
 * StatCard - KPI/Metric card component
 * Displays a single statistic with icon, value, label, and optional change indicator
 */
export const StatCard = ({ 
  label, 
  value, 
  icon, 
  change, 
  changeLabel,
  iconBg = 'bg-blue-100',
  iconColor = 'text-blue-600',
  className = '',
  size = 'default' // 'default' or 'compact'
}) => {
  const isPositive = change !== undefined && change >= 0;
  const isCompact = size === 'compact';
  
  const paddingClass = isCompact ? 'p-4' : 'p-6';
  const valueSizeClass = isCompact ? 'text-2xl' : 'text-3xl';
  const iconSizeClass = isCompact ? 'w-10 h-10' : 'w-12 h-12';
  const iconSvgSizeClass = isCompact ? 'w-5 h-5' : 'w-6 h-6';
  
  return (
    <div className={`bg-white rounded-xl ${paddingClass} border border-gray-200 shadow-sm hover:shadow-md transition-shadow ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">
            {label}
          </p>
          <p className={`${valueSizeClass} font-bold text-gray-900 mb-1`}>
            {value}
          </p>
          {change !== undefined && (
            <div className="flex items-center gap-1 mt-2">
              <span className={`text-sm font-semibold ${isPositive ? 'text-emerald-600' : 'text-red-600'}`}>
                {isPositive ? '↑' : '↓'} {Math.abs(change).toFixed(1)}%
              </span>
              {changeLabel && (
                <span className="text-xs text-gray-500">{changeLabel}</span>
              )}
            </div>
          )}
        </div>
        {icon && (
          <div className={`${iconBg} ${iconColor} ${iconSizeClass} rounded-xl flex items-center justify-center flex-shrink-0`}>
            {React.cloneElement(icon, { className: iconSvgSizeClass })}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
